// App shell (§11): left nav + content outlet. Dense, dark, monospace data. Cloudflare Access
// handles auth at the edge; the SPA assumes an authenticated session.

import { NavLink, Outlet } from "react-router-dom";

const NAV = [
  { to: "/", label: "Overview", end: true },
  { to: "/services", label: "Services" },
  { to: "/groups", label: "Groups" },
  { to: "/tasks", label: "Tasks" },
  { to: "/runs", label: "Runs" },
  { to: "/dlq", label: "DLQ" },
];

export function Layout() {
  return (
    <div className="flex min-h-full">
      <aside className="w-52 shrink-0 border-r border-border bg-surface">
        <div className="px-4 py-4">
          <div className="font-mono text-lg font-bold tracking-tight text-white">cadence</div>
          <div className="text-[11px] uppercase tracking-widest text-muted">scheduler</div>
        </div>
        <nav className="flex flex-col gap-0.5 px-2">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `rounded px-3 py-1.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-primary/15 text-primary" : "text-slate-300 hover:bg-bg hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="min-w-0 flex-1 overflow-x-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}